import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { BannerEditorComponent } from './banner-editor/banner-editor.component';

@Injectable({
  providedIn: 'root'
})
export class BannerEditorUnsavedChangesGuard implements CanDeactivate<BannerEditorComponent> {
  canDeactivate(component: BannerEditorComponent): boolean {
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}


